<template>
<div class="chapter">
<div class="inner_page">
<div id="contents">
<div class="generated-style">
<p class="x2fm-ttl" xml:lang="en-us">Contents</p>
<div id="cover">
<p class="x2toc"><em class="italic"><a href="#/Cover">Cover</a></em></p>
</div>
<div id="title-page">
<p class="x2toc"><em class="italic"><a href="#/Title_Page">Title Page</a></em></p>
</div>
<div id="dedication">
<p class="x2toc"><em class="italic"><a href="#/Dedication">Dedication</a></em></p>
</div>
<div id="chapter-1">
<p class="x2toc-after-txb1"><span class="generated-style"><a href="#/Chapter_1#chapter-1">Chapter 1</a></span></p>
</div>
<div id="chapter-2">
<p class="x2toc"><span class="generated-style"><a href="#/Chapter_2#chapter-2">Chapter 2</a></span></p>
</div>
<div id="chapter-3">
<p class="x2toc"><span class="generated-style"><a href="#/Chapter_3#chapter-3">Chapter 3</a></span></p>
</div>
<div id="chapter-4">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_4#chapter-4" title="Link target outside of Sample">Chapter 4</span></span></p>
</div>
<div id="chapter-5">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_5#chapter-5" title="Link target outside of Sample">Chapter 5</span></span></p>
</div>
<div id="chapter-6">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_6#chapter-6" title="Link target outside of Sample">Chapter 6</span></span></p>
</div>
<div id="chapter-7">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_7#chapter-7" title="Link target outside of Sample">Chapter 7</span></span></p>
</div>
<div id="chapter-8">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_8#chapter-8" title="Link target outside of Sample">Chapter 8</span></span></p>
</div>
<div id="chapter-9">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_9#chapter-9" title="Link target outside of Sample">Chapter 9</span></span></p>
</div>
<div id="chapter-10">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_10#chapter-10" title="Link target outside of Sample">Chapter 10</span></span></p>
</div>
<div id="chapter-11">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_11#chapter-11" title="Link target outside of Sample">Chapter 11</span></span></p>
</div>
<div id="chapter-12">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_12#chapter-12" title="Link target outside of Sample">Chapter 12</span></span></p>
</div>
<div id="chapter-13">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_13#chapter-13" title="Link target outside of Sample">Chapter 13</span></span></p>
</div>
<div id="chapter-14">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_14#chapter-14" title="Link target outside of Sample">Chapter 14</span></span></p>
</div>
<div id="chapter-15">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_15#chapter-15" title="Link target outside of Sample">Chapter 15</span></span></p>
</div>
<div id="chapter-16">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_16#chapter-16" title="Link target outside of Sample">Chapter 16</span></span></p>
</div>
<div id="chapter-17">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_17#chapter-17" title="Link target outside of Sample">Chapter 17</span></span></p>
</div>
<div id="chapter-18">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_18#chapter-18" title="Link target outside of Sample">Chapter 18</span></span></p>
</div>
<div id="chapter-19">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_19#chapter-19" title="Link target outside of Sample">Chapter 19</span></span></p>
</div>
<div id="chapter-20">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_20#chapter-20" title="Link target outside of Sample">Chapter 20</span></span></p>
</div>
<div id="chapter-21">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_21#chapter-21" title="Link target outside of Sample">Chapter 21</span></span></p>
</div>
<div id="chapter-22">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_22#chapter-22" title="Link target outside of Sample">Chapter 22</span></span></p>
</div>
<div id="chapter-23">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_23#chapter-23" title="Link target outside of Sample">Chapter 23</span></span></p>
</div>
<div id="chapter-24">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_24#chapter-24" title="Link target outside of Sample">Chapter 24</span></span></p>
</div>
<div id="chapter-25">
<p class="x2toc"><span class="generated-style"><span href="#/Chapter_25#chapter-25" title="Link target outside of Sample">Chapter 25</span></span></p>
</div>
<div id="afterword">
<p class="x2toc"><span class="generated-style"><span href="#/Afterword#afterword" title="Link target outside of Sample">Afterword</span></span></p>
</div>
<div id="glossary">
<p class="x2toc"><span class="generated-style"><span href="#/Glossary#glossary" title="Link target outside of Sample">A Glossary of the Damned</span></span></p>
</div>
<div id="acknowledgments">
<p class="x2toc-after-txb1"><em class="italic"><span href="#/Acknowledgments#acknowledgments" title="Link target outside of Sample">Acknowledgments</span></em></p>
</div>
<div id="about-the-author">
<p class="x2toc"><em class="italic"><span href="#/About_the_Author#about-the-author" title="Link target outside of Sample">About the Author</span></em></p>
</div>
<div id="also-by-the-author">
<p class="x2toc"><em class="italic"><span href="#/Also_by_the_Author#also-by-the-author" title="Link target outside of Sample">Also by Janet Mullany</span></em></p>
</div>
<div id="credits">
<p class="x2toc"><em class="italic"><span href="#/Credits#credits" title="Link target outside of Sample">Credits</span></em></p>
</div>
<div id="copyright">
<p class="x2toc"><em class="italic"><span href="#/Copyright#copyright" title="Link target outside of Sample">Copyright</span></em></p>
</div>
<div id="about-the-publisher">
<p class="x2toc"><em class="italic"><span href="#/About_the_Publisher#about-the-publisher" title="Link target outside of Sample">About the Publisher</span></em></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5f647822